<template>
  <div class="cities">
    <div class="container-fluid">
      <div>
        <h3 class="mb-4">المُدن</h3>
        <div class="cities__header d-flex">
          <div style="flex: 1">
            <el-input
              @input="searchInCities"
              prefix-icon="el-icon-search"
              placeholder="بحث في المُدن"
              v-model="search"
            ></el-input>
          </div>
          <div>
            <el-button type="primary" @click="addCityModal = true">
              إضافة
            </el-button>
          </div>
        </div>

        <div class="cities__body">
          <div class="row" v-if="cities.length > 0">
            <div class="col-md-4" v-for="city in cities" :key="city.id">
              <div class="d-flex cities__card">
                <div>
                  <h6>{{ city.name }}</h6>
                </div>
                <div class="locations__actions">
                  <div class="actions">
                    <div>
                      <button
                        @click="
                          (updateCityModel = true), (updateCity = { ...city })
                        "
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          id="Icon"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                        >
                          <rect
                            id="Area"
                            width="20"
                            height="20"
                            fill="#fcfcfc"
                            opacity="0"
                          />
                          <g
                            id="Icon-2"
                            data-name="Icon"
                            transform="translate(1.566 1.566)"
                          >
                            <path
                              id="Path"
                              d="M9.167,3.333H15A1.667,1.667,0,0,1,16.667,5V16.667A1.666,1.666,0,0,1,15,18.333H3.334a1.667,1.667,0,0,1-1.667-1.666V10.833"
                              transform="translate(0.101 -1.566)"
                              fill="none"
                              stroke="#919efa"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.667"
                            />
                            <path
                              id="Path-2"
                              data-name="Path"
                              d="M9.684,2.083a1.768,1.768,0,0,0-2.5,2.5L15.1,12.5l3.333.833L17.6,10Z"
                              transform="translate(-6.667 -1.566)"
                              fill="none"
                              stroke="#919efa"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.667"
                            />
                          </g>
                        </svg>
                      </button>
                    </div>

                    <div>
                      <el-popconfirm
                        :title="'هل أنت متأكد من الحذف ؟'"
                        :cancel-button-text="'إلغاء'"
                        :confirm-button-text="'حذف'"
                      >
                        <button slot="reference">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            id="Icon"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                          >
                            <rect
                              id="Area"
                              width="20"
                              height="20"
                              fill="#fcfcfc"
                              opacity="0"
                            />
                            <g
                              id="Icon-2"
                              data-name="Icon"
                              transform="translate(2.5 1.667)"
                            >
                              <path
                                id="Path"
                                d="M17.5,5H2.5"
                                transform="translate(-2.5 -1.667)"
                                fill="none"
                                stroke="red"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.667"
                              />
                              <path
                                id="Path-2"
                                data-name="Path"
                                d="M4.167,5V16.667a1.666,1.666,0,0,0,1.666,1.666h8.334a1.666,1.666,0,0,0,1.666-1.666V5m-2.5,0V3.333a1.666,1.666,0,0,0-1.666-1.666H8.333A1.666,1.666,0,0,0,6.667,3.333V5"
                                transform="translate(-2.5 -1.667)"
                                fill="none"
                                stroke="red"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.667"
                              />
                              <line
                                id="Line"
                                y2="5"
                                transform="translate(9.167 7.5)"
                                fill="none"
                                stroke="red"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.667"
                              />
                              <line
                                id="Line-2"
                                data-name="Line"
                                y2="5"
                                transform="translate(5.833 7.5)"
                                fill="none"
                                stroke="red"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.667"
                              />
                            </g>
                          </svg>
                        </button>
                      </el-popconfirm>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="no-data-img" v-else>
            <NoData />
          </div>
        </div>
      </div>
    </div>

    <vs-popup
      class="popup-width-300"
      title="إضافة مدينة جديدة"
      :active.sync="addCityModal"
    >
      <div class="popup-calender">
        <el-form :model="addCity" ref="addCity">
          <h6 class="mb-2">اسم المدينة</h6>
          <el-form-item
            style="min-width: 300px"
            prop="name"
            :rules="[{ required: true, message: 'المدينة مطلوبة' }]"
          >
            <el-input placeholder="المدينة"
                @keyup.enter="onUpdateSubmit('addCity')" 
             v-model="addCity.name"></el-input>
          </el-form-item>

          <el-form-item>
            <div>
              <el-button type="primary" @click="onSubmit('addCity')">
                إضافة
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>

    <!-- Update -->

    <vs-popup
      class="popup-width-300"
      title="تعديل مدينة"
      :active.sync="updateCityModel"
    >
      <div class="popup-calender">
        <el-form :model="updateCity" ref="updateCity">
          <h6>اسم المدينة</h6>
          <el-form-item
            style="min-width: 300px"
            prop="name"
            :rules="[{ required: true, message: 'المدينة' }]"
          >
            <el-input
              placeholder="المدينة"
              v-model="updateCity.name"
              @keyup.enter="onUpdateSubmit('updateCity')" 
            ></el-input>
          </el-form-item>

          <el-form-item>
            <div>
              <el-button type="primary" @click="onUpdateSubmit('updateCity')">
                حفظ التعديلات
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import NoData from "@/components/NoData.vue";
import axiosApi from "@/plugins/axios";
export default {
  components: {
    NoData,
  },
  created() {
    this.getCities();
  },
  data() {
    return {
      search: "",
      cities: [],
      allCities: [],
      locations: [{ label: "cvv", value: "vd" }],
      addCity: {},
      addCityModal: false,
      updateCity: {},
      updateCityModel: false,
    };
  },
  methods: {
    deleteCity(city) {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .delete(`/cities/${city.id}`)
        .then(() => {
          this.$vs.notify({
            title: "تم بنجاح",
            position: "top-center",
            color: "success",
            text: "تم الحذف بنجاح",
          });
          this.getCities();
        })
        .catch((err) => {
          if (err.response.status == 500) {
            this.$vs.notify({
              title: " عذرا",
              position: "top-center",
              color: "danger",
              text: "غير مسموح بحذف هذا العنصر",
            });
          }
        })
        .finally(() => loading.close());
    },
    searchInCities() {
      // const loading = this.$loading({
      //   lock: true,
      //   text: false,
      //   spinner: "el-icon-loading",
      //   background: "rgba(255,255,255,.7)",
      //   customClass: "fullscreen-loading",
      // });
      this.cities = this.allCities.filter((ele) => {
        return ele.name.includes(this.search);
      });
      // loading.close();
    },
    getCities() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .get(`/cities`)
        .then((res) => {
          this.cities = res.data;
          this.allCities = [...res.data];
        })
        .finally(() => loading.close());
    },

    onUpdateSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: false,
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.7)",
            customClass: "fullscreen-loading",
          });

          axiosApi
            .put(`/cities/${this.updateCity.id}`, this.updateCity)
            .then(() => {
              this.updateCityModel = false;
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم التعديل بنجاح",
              });
              this.getCities();
            })
            .catch((err) => {
              if (err.response.status == 422) {
                this.$vs.notify({
                  title: "حدث خطأ!",
                  position: "top-center",
                  color: "danger",
                  text: "هذه المحافظة موجودة من قبل",
                });
              }
            })
            .finally(() => loading.close());
        }
      });
    },

    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: false,
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.7)",
            customClass: "fullscreen-loading",
          });
          axiosApi
            .post(`/cities`, this.addCity)
            .then(() => {
              this.addCityModal = false;
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم الإضافة بنجاح",
              });
              this.addCity = {};
              this.getCities();
            })
            .catch((err) => {
              if (err.response.status == 422) {
                this.$vs.notify({
                  title: "حدث خطأ!",
                  position: "top-center",
                  color: "danger",
                  text: "هذه المحافظة موجودة من قبل",
                });
              }

              if (err.response.status == 400) {
                this.$vs.notify({
                  title: "هذه المدينة موجودة من قبل",
                  position: "top-center",
                  color: "danger",
                  text: "حدث خطا ما",
                });
              }
            })
            .finally(() => loading.close());
        }
      });
    },
  },
};
</script>

<style lang="scss">
.cities {
  padding: 10px;
  &__header {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: 15px;
  }
  &__card {
    padding: 10px;
    background: #fff;
    margin-bottom: 20px;
    justify-content: space-between;
    align-items: center;
    h6 {
      font-size: 17px;
      margin-bottom: 0;
    }
  }
  &__actions {
    align-items: center;

    .actions {
      gap: 10px;
      display: flex;
      align-items: center;
      button {
        background: none;
        border: none;
        outline: none;
      }
    }
    .text-success {
      font-family: "CairoSemiBold";
    }
    .text-grey {
      text-decoration: line-through;
    }
  }
}

.vs-popup--content {
  padding: 26px 22px 0 !important;
}
</style>